import React from 'react';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage} from 'react-intl';

import {signin as signInAction} from 'actions/auth/SigninAction';
import {activation as activationAction} from 'actions/auth/ActivationAction';
import {cancelSignIn as cancelSignInAction,
    beginJoin as beginJoinAction} from 'actions/creators/Auth';

import {beginPasswordRecovery as beginPasswordRecoveryAction} from 'actions/creators/PasswordRecovery';

import * as AuthError from 'constants/AuthError';
import { getInitialCountryCode } from 'shared/utils/functions';
import fastJoinCountriesRu from 'shared/dictionaries/fast-join-countries/ru.json';

const messages = defineMessages({
    authorization: {
        id: 'sign_in.title',
        defaultMessage: 'Авторизация'
    },
    requisite: {
        id: 'sign_in.requisite',
        defaultMessage: 'Логин или номер счета'
    },
    password: {
        id: 'sign_in.password',
        defaultMessage: 'Пароль'
    },
    logIn: {
        id: 'sign_in.log_in',
        defaultMessage: 'Войти'
    },
    resendActivation: {
        id: 'sign_in.resend_activation',
        defaultMessage: 'Отправить'
    },
    join: {
        id: 'sign_in.join',
        defaultMessage: 'Регистрация'
    },
    forgot: {
        id: 'sign_in.forgot',
        defaultMessage: 'Забыли логин или пароль'
    },
    activationSent: {
        id: 'sign_in.activation_sent',
        defaultMessage: 'Письмо с ссылкой для активации учетной записи отправлено на {email}'
    },
    phone: {
        id: 'sign_in.phone',
        defaultMessage: 'Номер телефона'
    },
    email: {
        id: 'sign_in.email',
        defaultMessage: 'E-mail'
    },
    login: {
        id: 'sign_in.login',
        defaultMessage: 'Логин'
    },
    or: {
        id: 'sign_in.or',
        defaultMessage: 'или'
    },
});

class SignIn extends React.Component {
    static propTypes = {
        errorCode: React.PropTypes.number,
        email: React.PropTypes.string,
        cancelSignInAction: React.PropTypes.func.isRequired,
        signInAction: React.PropTypes.func.isRequired,
        beginJoinAction: React.PropTypes.func.isRequired,
        beginPasswordRecoveryAction: React.PropTypes.func.isRequired,
        activationAction: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this._handleCloseClick = this._handleCloseClick.bind(this);
        this._handleLogInClick = this._handleLogInClick.bind(this);
        this._handleJoinClick = this._handleJoinClick.bind(this);
        this._handleForgotClick = this._handleForgotClick.bind(this);

        this._handleActivateClick = this._handleActivateClick.bind(this);

        this.renderResendActivation = this.renderResendActivation.bind(this);
        this.onSelectInputType = this.onSelectInputType.bind(this);
        this.onInputBlur = this.onInputBlur.bind(this);

        this.state = {
            activationSent: false,
            inputType: '',
        };
    }

    componentDidMount() {
        this.refs.login.focus();
    }

    _handleCloseClick(e) {
        e.preventDefault();
        this.props.cancelSignInAction();
    }

    _handleLogInClick(e) {
        e.preventDefault();

        const loginVal = this.refs.login.value;
        const passwordVal = this.refs.password.value;

        const isAvailableAcc = ['demo', '276502'].some(acc => acc === loginVal)

        if(window.location.host === "qa1.fp.kz"){
            this.props.signInAction({login: loginVal, password: isAvailableAcc ? passwordVal : ""});
        } else {
            this.props.signInAction({login: loginVal, password: passwordVal});
        }
    }

    _handleJoinClick(e) {
        e.preventDefault();
        this.props.beginJoinAction();
    }

    _handleForgotClick(e) {
        e.preventDefault();
        this.props.beginPasswordRecoveryAction();
    }

    _handleActivateClick(e) {
        e.preventDefault();
        this.props.activationAction({email: this.props.email});

        this.setState({
            activationSent: true
        });
    }

    onSelectInputType(e) {
        this.setState({
            inputType: e.target.name
        });

        this.refs.login.type = e.target.name;
        this.refs.login.focus();
    }

    onInputBlur(e) {
        if (e.target.value === '') {
            this.setState({
                inputType: ''
            })
        }
    }

    renderResendActivation(email, activationSent) {
        const activationSentLayout = (<div className="login--form__row form__row">
                <FormattedMessage id="sign_in.activation_sent" values={{email}}/>
            </div>);

        if (activationSent) {
            return activationSentLayout;
        }

        return (
            <div className="login--form__row form__row">
                <div className="error-message">
                    <FormattedMessage id="sign_in.errors.not_activated" values={{email}}/>
                </div>
                <button className="login--form__btn login--form__btn__js form__btn"
                        onClick={this._handleActivateClick}>
                    <FormattedMessage {...messages.resendActivation} />
                </button>
            </div>);
    }

    render() {
        const {errorCode, email, countryCode} = this.props;
        const {activationSent, inputType} = this.state;

        let message;

        if (errorCode === AuthError.NOT_FOUND) {
            message = { id: 'sign_in.errors.invalid_credentials' };
        } else if (errorCode === AuthError.BLOCKED) {
            message = { id: 'sign_in.errors.user_blocked' };
        } else if (errorCode === AuthError.WRONG_CERT) {
            message = { id: 'sign_in.errors.wrong_certificate' };
        } else if (errorCode === -100) {
            message = { id: 'sign_in.errors.internal' };
        } else if (errorCode === AuthError.WRONG_PASSWORD) {
            message = { id: 'sign_in.errors.invalid_credentials' };
        }

        const notActivated = errorCode === AuthError.NOT_ACTIVATED;

        let loginInputType = inputType;

        if (inputType === '') {
            loginInputType = 'text';
        }

        let loginInputPlaceholder = '';
        if (loginInputType === 'tel') {
            const { defaultCountryId } = getInitialCountryCode(countryCode)
            const country = fastJoinCountriesRu[defaultCountryId]
            const mask = `${country.mask}${"x".repeat(country.length)}`.replace(/\+/, '')
            loginInputPlaceholder = mask
        }
        if (loginInputType === 'email') {
            loginInputPlaceholder = 'example@mail.com'
        }

        return (
            <div className="modal modal--auth modal--auth-login modal__visible ">
                <div className="modal--dialog">
                    <div className="modal--header">
                        <div className="header-inner--logotype__link"></div>
                        <div className="header-inner__title">
                            <FormattedMessage {...messages.authorization} />
                        </div>
                        <button className="modal__close modal__close__green modal__close__js"
                                onClick={this._handleCloseClick}/>
                    </div>
                    <div className="modal--content">
                        <div className="modal--content__wrapper">
                            <form className="login--form form">
                                {notActivated && this.renderResendActivation(email, activationSent)}
                                {!notActivated && errorCode &&
                                <div className="error-message">
                                    <FormattedMessage {...message} />
                                </div>}
                                {errorCode !== -2 && 
                                    <div>
                                        <div className="login--form__row form__row">
                                            {inputType === '' && <div className="form__row__mask" style={{fontSize: 11}}>
                                                <FormattedMessage {...messages.login}>
                                                    {(m) => <a href="#" name="text" onClick={this.onSelectInputType}>{m}</a>}
                                                </FormattedMessage>
                                                &nbsp;<FormattedMessage {...messages.or} />&nbsp;
                                                <FormattedMessage {...messages.phone}>
                                                    {(m) => <a href="#" name="tel" onClick={this.onSelectInputType}>{m}</a>}
                                                </FormattedMessage>
                                                &nbsp;<FormattedMessage {...messages.or} />&nbsp;
                                                <FormattedMessage {...messages.email}>
                                                    {(m) => <a href="#" name="email" onClick={this.onSelectInputType}>{m}</a>}
                                                </FormattedMessage>
                                            </div>}
                                            <label className="login--form__label form__label">
                                                <FormattedMessage {...messages.requisite} />
                                            </label>
                                            <input ref="login"
                                                placeholder={loginInputPlaceholder}
                                                type={inputType}
                                                className="login--form__control form__control"
                                                onBlur={this.onInputBlur} />
                                        </div>
                                        <div className="login--form__row form__row">
                                            <label className="login--form__label form__label">
                                                <FormattedMessage {...messages.password} />
                                            </label>
                                            <input ref="password"
                                                type="password"
                                                className="login--form__control form__control"/>
                                        </div>
                                        <div className="login--form__row form__row">
                                            <button className="login--form__btn login--form__btn__js form__btn"
                                                    onClick={this._handleLogInClick}>
                                                <FormattedMessage {...messages.logIn} />
                                            </button>
                                        </div>
                                    </div>
                                }
                            </form>
                            <div className="modal--content__controls">
                                <a href="#" className="modal--auth__registration"
                                   onClick={this._handleJoinClick}>
                                    <FormattedMessage {...messages.join} />
                                </a>
                                <a href="#" className="modal--auth__forget"
                                   onClick={this._handleForgotClick}>
                                    <FormattedMessage {...messages.forgot} />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function select(state) {
    const errorCode = state.auth.get('authError');
    const email = state.auth.get('email');
    const countryCode = state.application.get('countryCode');

    return {
        countryCode,
        errorCode,
        email
    };
}

export default connect(select, {
    cancelSignInAction, signInAction, beginJoinAction, beginPasswordRecoveryAction, activationAction
})(SignIn);



// WEBPACK FOOTER //
// ./js/sport-betting/components/SignIn.jsx